(function() {
    'use strict';

    angular.module('app.companias', []);
})();
